(function () {
    'use strict';

    angular
        .module('news')
        .controller('NewsViewController', NewsViewController);
    NewsViewController.$inject = ['NewsService','$stateParams','$sce'];
    function NewsViewController(NewsService,$stateParams,$sce) {
        var vm = this;
        vm.flag                  = false;
        vm.new                   = [];
        // vm.list                  = list;

        function getNews() {

            vm.newsId = $stateParams.id;
            vm.flag = false;
            /* Load variables to CSV */
            NewsService.getNews(vm.newsId).then(function(response){
                vm.news = response.data.news;
                vm.flag = true;
                if(vm.news.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    console.log(vm.news);
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
            }).catch(function(err){
            });
        }
        getNews();

        vm.trustAsHtml = function trustAsHtml(string)
        {
            return $sce.trustAsHtml(string);
        };

        vm.trustAsResourceUrl = function trustAsResourceUrl(url)
        {
            url = url.replace("watch?v=", "v/");
            return $sce.trustAsResourceUrl(url);
        };

    }

})();